module.exports = {"secret_CrptoJS":"yesyesyes","firebase_Keys":{"apiKey":"AIzaSyDuLVK2-TD3zf9o0ni2C6fmMifmaLL_p9I","authDomain":"shopbox-35ae7.firebaseapp.com","databaseURL":"https://shopbox-35ae7.firebaseio.com","projectId":"shopbox-35ae7","storageBucket":"shopbox-35ae7.appspot.com","messagingSenderId":"486576798153"}}


//////////////////
// WEBPACK FOOTER
// ./src/keys.json
// module id = 284
// module chunks = 0